import React from 'react'
import Tooltip from 'uiKit/TooltipInfo/Tooltip'

interface LabelWithTooltipProps {
  text: string
  tooltipId: string
  tooltipText: string
  marginLeft?: number
  place?: 'top' | 'right' | 'bottom' | 'left'
}

// Inline, single-line label with info tooltip icon
// Uses existing Tooltip component, which renders a single-line ReactTooltip.
const LabelWithTooltip: React.FC<LabelWithTooltipProps> = ({ text, tooltipId, tooltipText, marginLeft = -6, place }) => {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap', marginLeft }}>
      {text ? <span>{text}</span> : null}
      <Tooltip tooltipId={tooltipId} tooltipText={tooltipText} place={place} />
    </span>
  )
}

export default LabelWithTooltip
